

import { Stack, Text, Button, Box } from '@mantine/core';
import { IconPlayerPlay } from '@tabler/icons-react';

interface Props {
  onStart: () => void;
  isLoading: boolean;
}

export default function SimulatorStartCard({ onStart, isLoading }: Props) {
  return (
    <Box
      mt="xl"
      p="xl"
      style={{
        backgroundColor: '#ffffff',
        borderRadius: 12,
        border: '1px solid #E4E7ED',
        maxWidth: 420,
        width: '100%',
      }}
    >
      <Stack align="center" gap="md" py="md">
        <Text size="lg" fw={700} ta="center" c="#2A3140">
          Preview Your Flow
        </Text>
        <Text size="sm" ta="center" c="#4E5A6B">
          Start a simulation to preview your flow as users will see it
        </Text>
        <Button
          leftSection={<IconPlayerPlay size={16} />}
          onClick={onStart}
          loading={isLoading}
          style={{ backgroundColor: '#415A91' }}
          radius="md"
          size="md"
        >
          Start Simulation
        </Button>
      </Stack>
    </Box>
  );
}
